module.exports = __webpack_public_path__ + "static/media/saga.466115f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/saga.svg
// module id = 198
// module chunks = 0